import { RequestCreditRewardForSignUpDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const requestCreditRewardForSignUpCallable = getCallable(
  RequestCreditRewardForSignUpDefinition
);
